/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type MessagesList_lists$ref = any;
export type MessageKind = "active" | "expired" | "%future added value";
export type MessagesListQueryVariables = {|
  kind: MessageKind
|};
export type MessagesListQueryResponse = {|
  +lists: ?{|
    +$fragmentRefs: MessagesList_lists$ref
  |}
|};
export type MessagesListQuery = {|
  variables: MessagesListQueryVariables,
  response: MessagesListQueryResponse,
|};
*/


/*
query MessagesListQuery(
  $kind: MessageKind!
) {
  lists {
    ...MessagesList_lists
    id
  }
}

fragment MessageCell_message on Message {
  id
  title
  body
  endDate
  messageableType
  messageDisplay {
    title
    body
    endDate
    id
  }
}

fragment MessagesList_lists on Lists {
  messages(kind: $kind, first: 1000) {
    edges {
      node {
        id
        ...MessageCell_message
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "kind",
    "type": "MessageKind!"
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  },
  {
    "kind": "Variable",
    "name": "kind",
    "variableName": "kind"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDate",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MessagesListQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Lists",
        "kind": "LinkedField",
        "name": "lists",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MessagesList_lists"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MessagesListQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Lists",
        "kind": "LinkedField",
        "name": "lists",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "MessageConnection",
            "kind": "LinkedField",
            "name": "messages",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MessageEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Message",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "messageableType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MessageDisplay",
                        "kind": "LinkedField",
                        "name": "messageDisplay",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v1/*: any*/),
            "filters": [
              "kind"
            ],
            "handle": "connection",
            "key": "MessagesList_messages",
            "kind": "LinkedHandle",
            "name": "messages"
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "MessagesListQuery",
    "operationKind": "query",
    "text": "query MessagesListQuery(\n  $kind: MessageKind!\n) {\n  lists {\n    ...MessagesList_lists\n    id\n  }\n}\n\nfragment MessageCell_message on Message {\n  id\n  title\n  body\n  endDate\n  messageableType\n  messageDisplay {\n    title\n    body\n    endDate\n    id\n  }\n}\n\nfragment MessagesList_lists on Lists {\n  messages(kind: $kind, first: 1000) {\n    edges {\n      node {\n        id\n        ...MessageCell_message\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '560cb2aaa1c9cce304dd50e4dac8150f';

module.exports = node;
